import { bookCoverImage } from "@/data/siteData";

export default function BookCover() {
  return (
    <figure className="book-cover" data-testid="book-cover">
      <img className="book-cover-image" src={bookCoverImage} alt="The Decision Gap book cover by Ashwini Patil" width={1250} height={2000} loading="lazy" decoding="async" data-testid="book-cover-image" />
      <figcaption className="book-cover-foot"><span>Official cover</span><span>The Decision Gap</span></figcaption>
    </figure>
  );
}
